var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm-box"},[_c('amapPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }